import React, { Component } from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import "./MoveFileModal.scss";
import Modal from "react-bootstrap/Modal";
import closeIcon from "../../assets/close.svg";

class MoveFileModal extends Component {
  state = {
    primaryLocation: "0",
    primaryLocations: [],
    subFolderLocation: "0",
    subFolderLocations: [{ id: "0", value: "Select sub Folder" }],
    subFolderList: [],
  };

  hasValidValues = () => {
    return this.state.primaryLocation !== "0"
      ? this.state.subFolderLocation !== "0"
        ? true
        : false
      : false;
  };

  onChangePrimaryOption = (e) => {
    let subFolderLocations = [{ id: "0", value: "Select sub Folder" }];
    let subFolders = this.state.subFolderList.filter(
      (subFolder) =>
        subFolder.parentId === e.target.value &&
        subFolder.id !== this.props.folderId
    );
    subFolderLocations = [...subFolderLocations, ...subFolders];

    this.setState({
      primaryLocation: e.target.value,
      subFolderLocations,
    });
  };

  onChangeSubFolderOption = (e) => {
    this.setState({ subFolderLocation: e.target.value });
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({});
    }
  }

  componentDidMount() {
    apolloClient
      .query({
        query: gql`
          query foldersForUser {
            foldersForUser {
              id
              title
              isArchive
              isRoot
              description
              instruction
              color {
                id
              }
              parentFolder {
                id
                title
              }
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        const roots = result.data.foldersForUser.filter((root) => root.isRoot);
        const subs = result.data.foldersForUser.filter((root) => !root.isRoot);

        let primaryLocations = [];
        let subFolderList = [];

        roots.map(
          (folder) =>
            (primaryLocations = [
              ...primaryLocations,
              { id: folder.id, value: folder.title },
            ]).sort((a, b) => a.value.localeCompare(b.value))
        );

        subs.map(
          (subFolder) =>
            (subFolderList = [
              ...subFolderList,
              {
                id: subFolder.id,
                value: subFolder.title,
                parentId: subFolder.parentFolder.id,
              },
            ]).sort((a, b) => a.value.localeCompare(b.value))
        );
        
        //repopulates sub folder locations so user does not have to re-select root folder option 
        //in dropdown for them to appear 
        let subFolderOptions = [{ id: "0", value: "Select sub Folder" }];
        let subFoldersSorted = subFolderList.filter(
          (subFolder) =>
            subFolder.parentId === this.props.rootFolder &&
            subFolder.id !== this.props.folderId
        );
        subFolderOptions = [...subFolderOptions, ...subFoldersSorted];      

        this.setState({
          primaryLocation: this.props.rootFolder,
          subFolderLocations: subFolderOptions,
          primaryLocations,
          subFolderList,
        });
      })
      .catch(() => {});
  }

  render() {
    return (
      <Modal
        className="move-file-modal"
        size="sm"
        centered
        show={this.props.showModal}
        onHide={this.props.handleClose}
      >
        <div className="move-file-modal-content">
          <div className="header">
            <div className="title is-size-h4">Move File to</div>
            <img
              className="close"
              src={closeIcon}
              alt="close"
              onClick={this.props.handleClose}
            />
          </div>

          <div className="body">
            <div className="form-groups">
              <div className="form-group">
                <label>
                  <strong>Primary Folder Location*</strong>
                </label>
                <select
                  name="primary"
                  onChange={this.onChangePrimaryOption}
                  value={this.state.primaryLocation}
                >
                  {this.state.primaryLocations.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.value}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>
                  <strong>Sub Folder Location*</strong>
                </label>
                <select
                  name="subFolder"
                  onChange={this.onChangeSubFolderOption}
                  value={this.state.subFolderLocation}
                >
                  {this.state.subFolderLocations.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.value}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="footer">
            <button
              className="btn-tertiary cancel-button"
              onClick={this.props.handleClose}
            >
              Cancel
            </button>
            <button
              className="btn-primary create-button"
              disabled={!this.hasValidValues()}
              onClick={() =>
                this.props.moveItems(
                  this.state.primaryLocation,
                  this.state.subFolderLocation
                )
              }
            >
              Move
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default MoveFileModal;
